"use client";

import { Form, Input, Button, Typography, message } from "antd";
import Cookies from "js-cookie";
import service from "../api/FetchInterceptor";
import {useNavigate} from "react-router-dom";

const { Title, Paragraph } = Typography;

const Login = () => {
    const [form] = Form.useForm();

    const navigate = useNavigate()

    const onLogin = async (values) => {
        try {
            const response = await service({
                method: "POST",
                url: "login",
                data: values,
            });

            Cookies.set("token", response.token, {
                expires: 7,
                secure: process.env.NODE_ENV === "production",
                sameSite: "strict",
                path: "/",
            });

            message.success("Connexion réussie !");

            navigate('/dashboard')
        } catch (error) {
            message.error(error.response?.data?.message || "Erreur de connexion");
            if (error.response?.data?.errors) {
                const apiErrors = error.response.data.errors;
                Object.keys(apiErrors).forEach((field) => {
                    form.setFields([
                        {
                            name: field,
                            errors: [apiErrors[field][0]],
                        },
                    ]);
                });
            }
        }
    };

    return (
        <div className="flex flex-col min-h-screen items-center justify-center md:bg-blue-50">
            <div className="w-full max-w-xl mx-4 p-6 rounded-lg bg-white mt-8 shadow">
                <Title level={3}>Connectez-vous</Title>

                <Paragraph>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Paragraph>

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onLogin}
                    className="mt-4"
                >
                    <Form.Item
                        label="Adresse e-mail"
                        name="email"
                        rules={[
                            { required: true, message: "L'adresse email est requise" },
                            { type: "email", message: "L'adresse email n'est pas valide" },
                        ]}
                    >
                        <Input placeholder="Entrez votre email" size="large" />
                    </Form.Item>

                    <Form.Item
                        label="Mot de passe"
                        name="password"
                        rules={[
                            { required: true, message: "Le mot de passe est requis" },
                            {
                                min: 8,
                                message: "Le mot de passe doit contenir au moins 8 caractères",
                            },
                        ]}
                    >
                        <Input.Password placeholder="Entrez votre mot de passe" size="large" />
                    </Form.Item>

                    <Button type="primary" htmlType="submit" size="large" block>
                        Connexion
                    </Button>
                </Form>
            </div>
        </div>
    );
}

export default Login